<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div id="categoryLoadingDiv" class="vs-con-loading__container">
      <vs-table
          :sst="true"
          @search="handleSearch"
          @change-page="handleChangePage"
          @sort="handleSort"
          v-model="selected"
          search
          :data="categories">

          <template slot="header">
             <div class="flex flex-wrap items-center w-full">
                <vs-button class="mb-4 md:mb-0 mr-2" type="filled" icon-pack="feather" icon="icon-download" @click="gridApi.exportDataAsCsv()"></vs-button>
                <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus-circle" @click="addUser()">Add Category</vs-button>
            </div>
          </template>

          <template slot="thead">
              <vs-th sort-key="name">Name</vs-th>
              <vs-th>Color</vs-th>
              <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].name" >
                      <span class="ml13 sm:text-1em mb-4" v-html="data[indextr].name"></span>
                  </vs-td>
                  <vs-td :data="data[indextr].color">
                    <div v-if="data[indextr].color">
                      <vs-chip class="ag-grid-cell-chip" :color="data[indextr].color"></vs-chip>
                    </div>
                    <div v-else>
                      <vs-chip class="ag-grid-cell-chip" color="primary"></vs-chip>
                    </div>
                  </vs-td>
                  <vs-td :data="data[indextr].name" >
                      <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                        <feather-icon icon="EditIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr])" />
                        <feather-icon icon="TrashIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="confirmDeleteRecord(data[indextr])" />
                      </div>
                  </vs-td>
              </vs-tr>
          </template>
      </vs-table>

      <div class="vx-row mt-base">
          <div class="vx-col w-full mb-2">
              <vs-pagination :total="totalPage" v-model="currentPage"></vs-pagination>
          </div>
      </div>

      <vs-popup  classContent="popup-example h-full" title="Create Category" :active.sync="activePromptAddCategory">
        <div id="createCategoryLoadingDiv" class="vs-con-loading__container">
          <form data-vv-scope="addCategoryForm">
            <div class="vx-row">
              <div class="vx-col sm:w-3/4 mb-2">
                <vs-input class="w-full" v-validate="'required'" label-placeholder="Name" ref="name" name="name" v-model="create_cat.name"/>
                <span class="text-danger text-sm"  v-show="errors.has('addCategoryForm.name')">This field is required</span>
              </div>
              <div class="vx-col sm:w-1/4 mb-2">
                <label>Color</label><br>
                <input style="width: 100px;" class="absolute cursor-pointer" type="color" v-model="create_cat.color">
              </div>
            </div>
          </form>
    
          <div  class="vx-row mt-4">
            <div  class="vx-col w-1/2 mb-2">
              <!-- <vs-button  v-on:click.prevent="addLanguage()" color="primary" type="filled">Add Language</vs-button> -->
            </div>
            <div  class="vx-col w-1/2 mb-2" align="right">
              <vs-button  v-on:click.prevent="validateAddCatForm()" color="primary" type="filled">Create Category</vs-button>
            </div>
          </div>

          <div align="right" class="vx-row mt-4">
            <div  class="vx-col w-full mb-2">
              
            </div>
          </div>
        </div>
      </vs-popup>

      <vs-popup  classContent="popup-example h-full" title="Update Category" :active.sync="activePromptEditCategory">
        <div id="updateCategoryLoadingDiv" class="vs-con-loading__container">
          <form data-vv-scope="editCategoryForm">
            <div class="vx-row">
              <div class="vx-col sm:w-3/4 mb-2">
                <vs-input class="w-full" v-validate="'required'" label-placeholder="Name" ref="name" name="name" v-model="update_cat.name"/>
                <span class="text-danger text-sm"  v-show="errors.has('editCategoryForm.name')">{{ errors.first('editCategoryForm.name') }}</span>
              </div>
              <div class="vx-col sm:w-1/4 mb-2">
                <label>Color</label><br>
                <input style="width: 100px;" class="absolute cursor-pointer" type="color" v-model="update_cat.color">
              </div>
            </div>
          </form>
          <div  class="vx-row mt-4">
            <div  class="vx-col w-1/2 mb-2">
              <!-- <vs-button  v-on:click.prevent="addEditLanguage()" color="primary" type="filled">Add Language</vs-button> -->
            </div>
            <div  class="vx-col w-1/2 mb-2" align="right">
              <vs-button  v-on:click.prevent="validateEditCatForm()" color="primary" type="filled">Update Category</vs-button>
            </div>
          </div>
        </div>
      </vs-popup>
    </div>
  </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import moduleQuestionManagement from '@/store/question-management/moduleQuestionManagement.js'


export default {
  components: {

  },
  data() {
    return {
      selected:[],
      key : null, 
      active : null,
      search : null,
      totalPage: 1,
      currentPage: 1,
      currentPage_ : 1,
      categories : [],
      roles : [],
      activePromptAddCategory : false,
      activePromptEditCategory : false,
      create_cat : {
        name : null,
        color : "#FF9300",
      },
      update_cat :{
        name : null,
        color : "#FF9300",
      },
      searchQuery: "",
      deleteCategoryData : null,
    }
  },
  watch: {
      currentPage(val) {
          this.searchCategory()
      }
  },
  computed: {

  },
  methods: {
    confirmDeleteRecord(category) {
      this.deleteCategoryData = category;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm Delete`,
        text: `You are about to delete this category ?`,
        accept: this.deleteRecord,
        acceptText: "Delete"
      })
    },
    deleteRecord() {
      this.$vs.loading();

      this.$store.dispatch("questionManagement/deleteCategory", { id : this.deleteCategoryData.id})
          .then(res => { 
              this.$vs.loading.close()
              this.$vs.notify({
                  title: "Success.",
                  text: "Category deleted successfully.",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success"
              });
          })
          .catch(err => { 
            this.$vs.loading.close()
          })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    },
    checkPermissions(permissions) {
        let user = JSON.parse(localStorage.getItem("userInfo"))
        if(user && user.permissions_array){
          for (let i = 0; i < permissions.length; i++){
              if(user.permissions_array.includes(permissions[i])) return true
          }
        }

        return false;
    },
    checkRoles(roles) {
        let user = JSON.parse(localStorage.getItem("userInfo"))
        if(user && user.roles_array){
            for (let i = 0; i < roles.length; i++){
                if(user.roles_array.includes(roles[i])) return true
            }
        }

        return false;
    },
    getRoleName(role) {
        return (role && role.name) ? role.name.charAt(0).toUpperCase() + role.name.slice(1) : ''
    },
    handleSearch(searching) {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        this.timer = setTimeout(() => {
            this.search = searching
            this.searchCategory()
        }, 2000);   
    },
    handleChangePage(page) {
        // this.searchCategory()
    },
    handleSort(key, active) {
        if(key){
            this.key = key
            this.active = active
            this.searchCategory()
        }
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if(val !== "all") {
        modelObj = { type: "equals", filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()
      this.statusFilter = this.isVerifiedFilter = { label: 'All', value: 'all' }
      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    addUser() {
      this.activeTab = 0
      this.activePromptAddCategory = true
    },
    async validateAddCatForm() {
      await this.$validator.validateAll('addCategoryForm').then(result => {
        if (result) this.createCatApi()
      })
    },
    createCatApi() {
      var self = this
      this.$vs.loading({
          container: '#createCategoryLoadingDiv',
          scale: 0.6
      })

      this.$store.dispatch("questionManagement/createCategory", this.create_cat)
        .then(res => { 
            this.$vs.loading.close('#createCategoryLoadingDiv > .con-vs-loading')
            this.activePromptAddCategory = false
            this.$vs.notify({
                title: "Success.",
                text: "Category created successfully.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success"
            });
        })
        .catch(err => { 
          this.$vs.loading.close('#createCategoryLoadingDiv > .con-vs-loading')
          Object.keys(err.data.errors).forEach(function(key) {
            self.errors.add({
              field: key,
              scope: "addUserForm",
              msg: err.data.errors[key][0],
            });
          });
        })
    },
    async editRecord(category) {
      this.update_cat = category;
      this.activePromptEditCategory = true
    },
    async validateEditCatForm() {
      await this.$validator.validateAll('editCategoryForm').then(result => {
        if (result) this.updateCatApi()
      })
    },
    updateCatApi() {
      var self = this
      this.$vs.loading({
          container: '#updateCategoryLoadingDiv',
          scale: 0.6
      })

      this.$store.dispatch("questionManagement/updateCategory", this.update_cat)
        .then(res => { 
            this.$vs.loading.close('#updateCategoryLoadingDiv > .con-vs-loading')
            this.activePromptEditCategory = false
            this.$vs.notify({
                title: "Success.",
                text: "Category updated successfully.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success"
            });
        })
        .catch(err => { 
          this.$vs.loading.close('#updateCategoryLoadingDiv > .con-vs-loading')
          Object.keys(err.data.errors).forEach(function(key) {
            self.errors.add({
              field: key,
              scope: "addUserForm",
              msg: err.data.errors[key][0],
            });
          });
        })
    },
    async searchCategory() {
      var self = this
      this.$vs.loading({
          container: '#categoryLoadingDiv',
          scale: 0.6
      })

      await this.$store.dispatch("questionManagement/viewCategory", { search : this.search, sort : this.key, sortKey : this.active, page : this.currentPage})
        .then(res => { 
          this.totalPage = res.data.last_page
          this.$vs.loading.close('#categoryLoadingDiv > .con-vs-loading')
        })
        .catch(err => { 
          this.$vs.loading.close('#categoryLoadingDiv > .con-vs-loading')
        })

        this.categories = this.$store.state.questionManagement.categories
    },
    async viewCategories() {
      var self = this

      await this.$store.dispatch("questionManagement/viewCategory", {page : this.currentPage})
        .then(res => { 
          this.totalPage = res.data.last_page
        })

      this.categories = this.$store.state.questionManagement.categories
    },
  },
  mounted() {
    var self = this
    this.categories = this.$store.state.questionManagement.categories
    this.roles = this.$store.state.questionManagement.roles

    

    

    // console.log(this.create_catategories)
  },
  async created() {
    var self = this
    // Register Module UserManagement Module
    if(!moduleQuestionManagement.isRegistered) {
      this.$store.registerModule('questionManagement', moduleQuestionManagement)
      moduleQuestionManagement.isRegistered = true
    }

  
    await this.viewCategories()
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position : absolute;
      right : 0;
      top : 50%;
      transform : translateY(-58%);
    }
  }
}

</style>

<style type="text/css">

.pagidropdown{
    padding: 11px!important;
}

.rounded-full {
    border-radius: 7px !important;
}

.studentSearchBtn{
  width: 34% ! important;
}

.studentSearchStatus{
  width: 17% ! important;
}

.studentSearchEmail{
  width: 17% ! important;
}
</style>